import { Pipe, PipeTransform } from '@angular/core';
import { MemberCarePlanActivity } from 'src/app/core/models/member-care-plan-activity';

@Pipe({ name: 'filterNotes' })
export class FilterNotesPipe implements PipeTransform {
  transform(goalNotesList: MemberCarePlanActivity[], goalId: number): MemberCarePlanActivity[] {
    if (goalNotesList && goalNotesList.length) {
      return goalNotesList.filter((goalNotes) => String(goalNotes.entityid) === String(goalId));
    }
  }
}
